import Config from '../config/Config.js';
import FcmTokenService from '../firebase/FcmTokenService.js';

class Security {
	static logout() {
		fetch(Config.get('apiUrlBase') + '/auth/logout', {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization-Token': localStorage.getItem("token")
			}
		}).finally(() => {
			// Delete FCM token before clearing the auth token from localStorage
			FcmTokenService.eliminarTokenActual().finally(() => {
				localStorage.removeItem("token");
				localStorage.removeItem("persona");
				localStorage.removeItem("config");
				localStorage.removeItem("configBusiness");
				localStorage.removeItem("userLocale");
				window.location.href = '';
			});
			localStorage.removeItem("token");
			localStorage.removeItem("persona");
			localStorage.removeItem("config");
			localStorage.removeItem("configBusiness");
			localStorage.removeItem("userLocale");
			localStorage.removeItem("eric:history");
			window.location.href = '';
		});
	}

	static hasPermission(permission) {
		return this.hasAllPermissions([permission]);
	}

	static hasAnyPermission(permissions) {
		let hasAnyPermission = false;
		let persona = JSON.parse(localStorage.getItem("persona"));
		if(permissions && persona && persona.usuario && persona.usuario.perfil && persona.usuario.perfil.permisos) {
			let permisos = persona.usuario.perfil.permisos;
			hasAnyPermission = permisos.some(p => permissions.indexOf(p) >= 0);
		}
		return hasAnyPermission;
	}

	static hasAllPermissions(permissions) {
		let hasAllPermissions = false;
		let persona = JSON.parse(localStorage.getItem("persona"));
		if(persona && persona.usuario && persona.usuario.perfil && persona.usuario.perfil.permisos) {
			let permisos = persona.usuario.perfil.permisos;
			hasAllPermissions = permissions.every(p => permisos.indexOf(p) >= 0);
		}
		return hasAllPermissions;
	}

	static isInternal() {
		let persona = JSON.parse(localStorage.getItem("persona"));
		return persona ? persona.is_internal : false;
	}

	// Espeja Configuration::isLocalDevEnvironment() || isTestEnvironment() del backend.
	// El appEnv viaja en el response de los endpoints /auth/*/login (ver AuthController).
	static isLocalDevEnvironment() {
		let persona = JSON.parse(localStorage.getItem("persona"));
		let appEnv = persona && persona.appEnv;
		return appEnv === 'dev' || appEnv === 'test';
	}

	static renderIfHasPermission(permission, jsx) {
		return this.hasPermission(permission) ? jsx : '';
	}

	static renderIfHasAnyPermission(permissions, jsx) {
		return this.hasAnyPermission(permissions) ? jsx : '';
	}

	static renderIfHasAllPermissions(permissions, jsx) {
		return this.hasAllPermissions(permissions) ? jsx : '';
	}
}

export default Security;
